import { FC } from 'react'
import { AiFillEdit } from 'react-icons/ai'
import { Link } from 'react-router-dom'
import useIconInfo from '../../../hooks/useIconInfo'

type Props = {
  linkPath: string
}

const EditButton: FC<Props> = (props) => {
  const { linkPath } = props
  const { iconSize } = useIconInfo()

  return (
    <>
      <span id="edit">
        <Link to={linkPath}>
          <AiFillEdit size={iconSize} title="編集" />
        </Link>
      </span>
    </>
  )
}

export default EditButton
